export const Field = ({ label, htmlFor, hint, error, optional, children, testid }) => (
  <div className="space-y-1.5" data-testid={testid}>
    {label && (
      <label htmlFor={htmlFor} className="block text-sm font-semibold text-slate-900">
        {label} {optional && <span className="font-normal text-slate-500">(optional)</span>}
      </label>
    )}
    {hint && <p className="text-sm text-slate-600" id={htmlFor ? `${htmlFor}-hint` : undefined}>{hint}</p>}
    {children}
    {error && <p className="text-sm font-medium text-destructive" role="alert" data-testid={htmlFor ? `${htmlFor}-error` : undefined}>{error}</p>}
  </div>
);

export const ChoiceGroup = ({ name, value, onChange, options, testid, label }) => (
  <div role="radiogroup" aria-label={label} className="flex flex-wrap gap-2" data-testid={testid}>
    {options.map((o) => (
      <label key={o.value} className={`choice ${value === o.value ? "choice-on" : ""}`} data-testid={`${testid}-${o.value}`}>
        <input type="radio" className="sr-only" name={name} value={o.value} checked={value === o.value} onChange={() => onChange(o.value)} />
        {o.label}
      </label>
    ))}
  </div>
);

export const PlateInput = ({ id, value, onChange, error, testid = "registration-input" }) => (
  <div className={`plate ${error ? "ring-2 ring-destructive" : ""}`}>
    <span className="plate-badge" aria-hidden>UK</span>
    <input
      id={id} className="plate-input" value={value} placeholder="AB12 CDE" maxLength={10}
      onChange={(e) => onChange(e.target.value.toUpperCase())}
      autoComplete="off" autoCapitalize="characters" autoCorrect="off" spellCheck={false} enterKeyHint="next"
      aria-invalid={!!error} data-testid={testid}
    />
  </div>
);

export const TestBanner = ({ text }) => (
  <div className="border-b-2 border-amber-500 bg-amber-100 px-4 py-2 text-center text-sm font-semibold text-amber-950" role="status" data-testid="sandbox-test-banner">
    {text || "SANDBOX TEST MODE – test data only. Not a real valuation or offer. Visible only to signed-in dealer staff."}
  </div>
);
